import apiClient from "../config";

// Types
export interface Course {
  id: number;
  courseName: string;
  courseCategory: {
    id: number;
    categoryName: string;
  };
  shortVideoEnabled: boolean;
  free?: boolean;
  amount?: number;
}

export interface MemberCourse {
  course: Course;
  whatsappLink: string;
}

export interface FacilitatorInfo {
  fullName: string;
  verified: boolean;
}

export interface Category {
  id: number;
  categoryName: string;
}

export const getMemberInfo = async (
  memberNo: string
): Promise<FacilitatorInfo> => {
  const { data } = await apiClient.get(`/public/getMemberInfo/${memberNo}`);
  return data;
};

export const getOngoingCourses = async (
  memberNo: string
): Promise<MemberCourse[]> => {
  const { data } = await apiClient.get(
    `/public/ongoingMemberCourses/${memberNo}`
  );
  return data;
};

export const getUplineMemberNo = async (memberNo: string): Promise<string> => {
  const { data } = await apiClient.get(`/public/getUplineMemberNo/${memberNo}`);
  return data;
};

export const getCourseVideoId = async (courseId: number): Promise<string> => {
  const { data } = await apiClient.get(
    `/public/getCourseVideoLink/${courseId}`
  );
  const urlVideo = data;
  let videoId = urlVideo.split("v=")[1] || urlVideo.split("youtu.be/")[1] || "";
  const ampersandPosition = videoId.indexOf("&");
  if (ampersandPosition !== -1) {
    videoId = videoId.substring(0, ampersandPosition);
  }
  return videoId;
};

export const getCategories = async (): Promise<Category[]> => {
  const { data } = await apiClient.get(`/public/getCategories`);
  return data;
};
